import { PrimeDynamicDialogService } from '@adapter/dialog/primeng-dynamic-dialog.service';
import { AppDialogGateway } from '@service/dialog/app-dialog.gateway';
import { AppDialogService } from '@service/dialog/app-dialog.service';
import { DialogService } from 'primeng/dynamicdialog';

/**
 * Proveedor del gateway de diálogo
 */
const getDialogServiceProvider = {
  provide: AppDialogGateway,
  useClass: PrimeDynamicDialogService
};

/**
 * Factoria para el servicio de confirmación
 * @param gateway gateway de confirmación
 * @returns implementación del servicio
 */
const getDialogServiceFactory = (gateway: AppDialogGateway) => {
  return new AppDialogService(gateway);
};

/**
 * Proveedor del servicio de diálogo
 */
const getDialogService = {
  provide: AppDialogService,
  useFactory: getDialogServiceFactory,
  deps: [AppDialogGateway]
};

/**
 * Proveedor del servicio de diálogo de primeng
 */
const getPrimeDialogService = {
  provide: DialogService,
  useClass: DialogService
};

/**
 * DI de diálogo
 */
export const getDialogDi = [
  getPrimeDialogService,
  getDialogServiceProvider,
  getDialogService
];
